module.exports = __webpack_public_path__ + "static/media/1POLICY44.7cba4365.jpg";